import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tab 1")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Tab 2")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Tab 3")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")

  return (_openBlock(), _createBlock(_component_ion_tab_bar, { slot: "bottom" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_tab_button, {
        tab: "tab1",
        href: "/tabs/tab1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { icon: $setup.triangle }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_tab_button, {
        tab: "tab2",
        href: "/tabs/tab2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { icon: $setup.ellipse }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_tab_button, {
        tab: "tab3",
        href: "/tabs/tab3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { icon: $setup.square }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}